// removed by extract-text-webpack-plugin
module.exports = {"app":"_1kG1","rect":"BODy","drop":"euj8","screen":"_18mE","panel":"_2sBM","state":"U0xx","bottom":"Y47z"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/index.less
// module id = 245
// module chunks = 0